// extracted by mini-css-extract-plugin
module.exports = {"loadMoreNoteBtn":"style_loadMoreNoteBtn__1sxRj"};